import {
  useProjectProfitSummaryQuery,
  useProjectProfitTableDataQuery,
} from "@src/__generated__/urql-graphql";
import { useEffect } from "react";
import type { Store } from "../store";

export const useFetchTableData = (store: Store) => {
  const [{ fetching, data }] = useProjectProfitTableDataQuery({
    variables: {
      filters: store.reportStore.filters,
    },
  });

  const [{ fetching: fetchingSummary, data: summaryData }] =
    useProjectProfitSummaryQuery({
      variables: {
        filters: store.reportStore.filters,
      },
    });

  useEffect(() => {
    if (!data) return;
    store.setTableData(data);
  }, [data]);

  useEffect(() => {
    if (!summaryData) return;
    store.setSummary(summaryData);
  }, [summaryData]);

  return [fetching, fetchingSummary];
};
